export default function swDev() {
  if (!("serviceWorker" in navigator)) {
    return;
  }
  let url = `${process.env.PUBLIC_URL}/sw.js`;
  navigator.serviceWorker
    .register(url)
    .then((response) => {
      console.warn("response", response);
    })
    .catch((error) => {
      console.error("Service worker registration failed", error);
    });
  navigator.serviceWorker.ready.then(function (swRegistration) {
    //return swRegistration.sync.register("myFirstSync");
  });
}
